import React from 'react'
import Button from '../../Buttons/Button'
import './index.scss'
import { observer } from 'mobx-react'
import { action } from 'mobx'

interface IProps {
    limit: number
    buttonValues: number[]
    onChange: (newLimit: number) => void
}

const ResultsPerPage = observer((props: IProps) => {
    const onClick = action((value: number) => {
        if (value !== props.limit) {
            props.onChange(value)
        }
    })

    const determineButtonType = (buttonValue: number) =>
        buttonValue === props.limit ? 'primary-small' : 'secondary-small'

    return (
        <section className="results-per-page">
            <p className="small bold">Results Per Page:</p>
            {props.buttonValues.map((buttonValue: number, index: number) => (
                <Button
                    key={index}
                    mainColor
                    type={determineButtonType(buttonValue)}
                    className="rpp-button"
                    onClick={() => onClick(buttonValue)}
                >
                    {buttonValue}
                </Button>
            ))}
        </section>
    )
})

export default ResultsPerPage
